import React, { createContext, useContext, useMemo } from 'react';

const DesignerDerivedContext = createContext({
  decisionPredicates: new Map(),
  edgeSourceTypes: new Map(),
  defaultEdgeType: 'smoothstep',
  edgeFontPx: 14,
  arrowSize: 18,
});

export const DesignerDerivedProvider = ({ nodes, edges, defaultEdgeType = 'smoothstep', edgeFontPx = 14, arrowSize = 18, children }) => {
  const value = useMemo(() => {
    const nodeById = new Map(nodes.map(n => [n.id, n]));

    const decisionPredicates = new Map();
    for (const n of nodes) {
      if (n.type !== 'decision') continue;
      const inbound = edges.find(e => e.target === n.id);
      const upstream = inbound ? nodeById.get(inbound.source) : null;
      const testVar = upstream?.data?.variable || upstream?.data?.variable_name;
      let predicate;
      if (testVar) {
        predicate = `${testVar}?`;
      } else {
        const fallback = n.data?.text || n.data?.label || 'Decision';
        predicate = String(fallback).endsWith('?') ? String(fallback) : `${fallback}?`;
      }
      decisionPredicates.set(n.id, predicate);
    }

    const edgeSourceTypes = new Map();
    for (const e of edges) {
      edgeSourceTypes.set(e.id, nodeById.get(e.source)?.type);
    }

    return { decisionPredicates, edgeSourceTypes, defaultEdgeType, edgeFontPx, arrowSize };
  }, [nodes, edges, defaultEdgeType, edgeFontPx, arrowSize]);

  return (
    <DesignerDerivedContext.Provider value={value}>
      {children}
    </DesignerDerivedContext.Provider>
  );
};

export const useDesignerDerived = () => useContext(DesignerDerivedContext);
